import React from 'react';
import { useReveal } from '../lib/useReveal';
import { cn } from '../lib/cn';

export const Stats = ({ data }) => {
  const ref = useReveal();
  const items = data?.items || [];
  if (items.length === 0) return null;

  return (
    <section
      className="bg-paper-soft border-y border-rule text-ink relative"
      aria-label={data?.eyebrow}
    >
      <div className="max-wrap section-wrap">
        <div ref={ref} className="reveal py-12 sm:py-16">
          {data?.eyebrow && (
            <div className="flex items-center gap-4 mb-10 sm:mb-14">
              <span className="font-mono text-[0.68rem] uppercase tracking-[0.22em] text-ink-muted">
                {data.eyebrow}
              </span>
              <span className="flex-1 h-px bg-rule" aria-hidden="true" />
            </div>
          )}

          <dl className="grid grid-cols-2 lg:grid-cols-3">
            {items.map((item, i) => {
              const isMobileSecondCol = i % 2 === 1;
              const isMobileSecondRow = i >= 2;
              const isNotFirstDesktopCol = i > 0;
              return (
                <div
                  key={i}
                  className={cn(
                    'px-4 py-6 sm:px-6 sm:py-8 lg:border-t-0',
                    isMobileSecondCol && 'border-l border-rule',
                    isMobileSecondRow && 'border-t border-rule',
                    isNotFirstDesktopCol && 'lg:border-l lg:border-rule'
                  )}
                >
                  <dt className="order-2 mt-3 font-mono text-[0.68rem] uppercase tracking-[0.22em] text-ink-muted">
                    {item.label}
                  </dt>
                  <dd
                    className="order-1 font-serif text-ink tracking-tightest leading-none text-balance flex items-baseline gap-1"
                    style={{ fontSize: 'clamp(2.5rem, 6.5vw, 4.5rem)' }}
                  >
                    <span>{item.value}</span>
                    {item.suffix && (
                      <span
                        className="font-sans text-ink-muted tracking-normal"
                        style={{ fontSize: 'clamp(0.85rem, 1.3vw, 1.1rem)' }}
                      >
                        {item.suffix}
                      </span>
                    )}
                  </dd>
                </div>
              );
            })}
          </dl>
        </div>
      </div>
    </section>
  );
};
